<template>
    <div class="section-invite">
        <div class="content">
            <section class="section-efficient-architecture">
                <div class="title-section">高效采购</div>

                <div class="list">
                    <div class="item" v-for="(item, index) in webInfo.home.gxzcList" :key="index">
                        <div class="card">
                            <el-image class="img" :src="item.img" fit="cover"></el-image>

                            <div class="info">
                                <div class="title">{{item.title}}</div>
                                <div class="text">{{item.text}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section-intelligent-manageability">
                <div class="title-section">智慧管理</div>

                <div class="list">
                    <div v-for="(item, index) in imList" :key="index" class="item">
                        <div class="card" :style="{backgroundImage: `url(${item.bg})`}">
                            <div class="title">{{item.title}}</div>
                            <div class="text">{{item.text}}</div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            imList: [
                 {
                        bg: '/images/hzyc/home/zhgl1.png',
                        title: '分级授权  进度管控',
                        text: '跨部门协作，自动化流程，打通信息壁垒，统一管理采购进程，关键节点信息推送，减少人工操作。',
                    },
                    {
                        bg: '/images/hzyc/home/zhgl2.png',
                        title: '合同履约  一键归档',
                        text: '快速完成合同及归档，且对整个履约做到全程把控，提前预警。',
                    },
                    {
                        bg: '/images/hzyc/home/zhgl3.png',
                        title: '风险预警  成本管理',
                        text: '采购全流程内外方多维度、多节点风险及成本管控，降低采购成本，异常自动通知，风险预警。',
                    },
                    {
                        bg: '/images/hzyc/home/zhgl4.png',
                        title: '数据赋能  科学决策',
                        text: '采购全流程多节点埋点，借助数据分析、数据报告，AI机会识别、供应商洞察、价格趋势等让决策更科学。',
                    },
            ],
        };
    },
    mounted(){
       
    },
};
</script>

<style lang="scss" scoped>
.section-invite {
    background-image: linear-gradient(180deg, #ffffff 0%, #ecf3ff 100%);
    padding-bottom: 80px;

    .section-efficient-architecture {
        .title-section {
            padding: 30px 0 60px;
            font-weight: normal;
        }

        .list {
            display: flex;

            .item {
                flex: 1;
                align-items: center;
                cursor: default;

                .card {
                    background: white;
                    width: 267px;
                    height: 323px;
                    box-shadow: 0 0 15px #d9e2f2;
                    padding: 4px;
                    transition: all 0.3s;

                    .img {
                        width: 259px;
                        height: 146px;
                    }

                    .info {
                        padding: 14px;

                        .title {
                            font-size: 20px;
                            color: #333333;
                            font-weight: bold;
                            text-align: center;
                            line-height: 1em;
                        }

                        .text {
                            font-size: 16px;
                            color: #333333;
                            margin-top: 22px;
                            line-height: 25px;
                        }
                    }

                    &:hover {
                        transform: translateY(-15px);
                    }
                }
            }
        }
    }

    .section-intelligent-manageability {
        .title-section {
            padding: 80px 0 70px;
            font-weight: normal;
        }

        .list {
            display: flex;

            .item {
                flex: 1;
                cursor: default;

                .card {
                    background-size: cover;
                    width: 282px;
                    height: 181px;
                    color: #ffffff;
                    padding: 22px 12px;

                    .title {
                        font-size: 20px;
                        line-height: 1em;
                        margin-bottom: 24px;
                    }

                    .text {
                        font-size: 16px;
                        line-height: 25px;
                    }
                }
            }
        }
    }
}
</style>